export const
    UPDATE_GRID = 'UPDATE_GRID',
    DELETE_GRID = 'DELETE_GRID';

export const updateGrid = (name, config) => {
    return {
        type: UPDATE_GRID,
        name,
        config
    };
};

export const deleteGrid = name => {
    return {
        type: DELETE_GRID,
        name
    };
};
